import { AfterViewInit, Component, Input } from '@angular/core';

@Component({
  selector: 'rr-tab-control',
  standalone: false,

  templateUrl: './tab-control.component.html',
  styleUrl: './tab-control.component.scss'
})
export class TabControlComponent implements AfterViewInit {
  @Input() activeStep: number = 1;
  steps: any[] = []
  tabs: NodeList | undefined;

  constructor() {
    setTimeout(() => {
      this.setActiveTab(this.activeStep);
      console.log('active Step', this.activeStep);
    }, 100);
  }

  setActiveTab(index: number) {
    this.activeStep = index;
    this.showActiceStepOnly();
  }
  ngAfterViewInit(): void {
    this.tabs = document.querySelectorAll('rr-tab');
    this.tabs.forEach((tab) => {
      const label = (tab as Element).getAttribute('label');
      const step = (tab as Element).getAttribute('step');
      this.steps.push({ label, index: parseInt(step || '1') })
    })
    this.steps.sort((a, b) => a.index - b.index);
    this.showActiceStepOnly();

  }
  showActiceStepOnly() {
    this.tabs?.forEach((tab) => {
      const step = (tab as Element).getAttribute('step');
      if (parseInt(step || '1') === this.activeStep) {
        (tab as Element).classList.remove('hidden')
      } else {
        (tab as Element).classList.add('hidden')
      }
    })
  }
}
